import React from 'react'
import { useIntl } from 'react-intl'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import styled from 'styled-components'
import { CRUISE_CONTACT } from 'constants/cruise'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import TextLink from 'LuxKit/TextLink'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const SameHeightPaneSm = styled(Pane)`
  margin-top: ${rem(32)};

  ${mediaQueryUp.tablet} {
    margin-top: 0;
    height: 100%;
  }
`

const ContactContent = styled(PaneBody)`
  display: grid;

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const Root = styled(VerticalSpacer)`
  text-align: center;
`

function CruisesContact() {
  const intl = useIntl()

  return <Pane>
    <PaneBody size="xl-y md">
      <LayoutContainer>
        <Heading variant="heading2" align="center" as="h2">
          {intl.formatMessage({
            id: 'iHbLe1QgGF',
            defaultMessage: 'Need help? Get in touch with us.',
            description: 'Heading for cruise contact section',
          })}
        </Heading>
        <ContactContent size="xl-y">
          {/* TODO: i18n - CRUISE_CONTACT constant values (title, text, subText) need localisation. Consider converting to a hook or accepting intl parameter. */}
          {CRUISE_CONTACT.map(({ Icon, title, text, subText, link }, i) => {
            return (
              <SameHeightPaneSm key={i}>
                <PaneBody size="lg xl-y">
                  <Root gap={16}>
                    <Icon size={30} colour="primary" />
                    <div>
                      <BodyText variant="medium" weight="bold">
                        {title}
                      </BodyText>
                      <BodyText variant="small" as="p">
                        {text}
                      </BodyText>
                      <TextLink size="small" weight="bold" href={link}>
                        {subText}
                      </TextLink>
                    </div>
                  </Root>
                </PaneBody>
              </SameHeightPaneSm>
            )
          })}
        </ContactContent>
      </LayoutContainer>
    </PaneBody>
  </Pane>
}

export default CruisesContact
